/**
 * Created by gaolifa on 2020/07/07.
 */
import axios from 'axios';
import qs from 'qs';
import {message} from 'antd';

let cancels = [];
// 初始化 设置钩子函数
let _before, _error, _success, _complete;

export function init(options) {
    const defaultOptions = {
        before() {
        }, error() {
        }, success() {
        }, complete() {
        },
    };
    options = Object.assign({}, defaultOptions, options);
    _before = options.before;
    _error = options.error;
    _success = options.success;
    _complete = options.complete;
}

function handleError(err) {
    const isCanceled = err && err.message && err.message.canceled;
    if (isCanceled) return;
    _error(err);
}

function setOptions(axiosInstance) {
    axiosInstance.interceptors.request.use(config => {
        // 在发送请求之前做某事
        _before();
        return config;
    }, error => {
        // 请求错误时做些事
        // _error(error)
        _complete();
        return Promise.reject(error);
    });

    axiosInstance.interceptors.response.use(response => {
        _success(response);
        _complete();
        return response;
    }, error => {
        _complete();
        handleError(error);
        const { response = {} } = error;
        const { status = 0 } = response;


        //token 过期，跳转到登录页面
        if (status === 401) {
            localStorage.removeItem('userInfo');
            window.history.replaceState(undefined, undefined, '/login');
            window.history.go(0);
        } 
        
        // else if (status === 403) {
        //     window.history.replaceState(undefined, undefined, '/privatisation/permission');
        //     window.history.go(0);
        // }
        message.destroy();
        return Promise.reject({
            code: response?.data?.code,
            message: `${ response?.data?.msg ?? '' } [${ response?.data?.code?? '' }]`,
        });
    });
}

export function newAxios(options = {}) {
    const { globalHandle = true, isTransformRequest = true } = options;
    const CancelToken = axios.CancelToken;
    const config = {
        cancelToken: new CancelToken(c => {
            // 一个执行器函数接收一个取消函数作为参数
            cancels.push(c);
        }),
    };
    if (isTransformRequest) {
        config.transformRequest = [data => {
            // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
            data = qs.stringify(data);
            return data;
        }];
    }
    const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : '';
    const language = navigator.language || navigator.userLanguage;
    const instance = axios.create(config);
    instance.defaults.headers.common['language'] = language;
    instance.defaults.headers.common['Content-Type'] = 'application/json';
    instance.defaults.headers.common['Authorization'] = userInfo && ('Bearer ' + userInfo.token);

    if (globalHandle) {
        setOptions(instance);
    }
    return instance;
}

/**
 * get请求参拼接url
 * @param {String} method
 * @param {*String} url
 * @param {*Object} data
 */
export const http = (method, url, data) => {
    let requestUri = url;
    const fetch = newAxios({ isTransformRequest: !url.includes('/v1') });
    if (!url.includes('http')) {
        if (process.env.NODE_ENV === 'development') {
            if (url.includes('/v1')) {
                requestUri = '/privateApi' + url;
            } else {
                requestUri = '/accountOrAppApi' + url;
            }
        } else {
            requestUri = process.env.REACT_APP_API_HOST + url;
        }
    }

    // requestUri = process.env.REACT_APP_API_HOST + url;
    if (method === 'get') {
        let arr = [];
        let Url;
        if (data) {
            Object.entries(data).forEach(([k, val]) => {
                arr.push(`${ k }=${ val }`);
            });
            arr = arr.join('&');
            Url = requestUri + '?' + arr;
        } else {
            Url = requestUri;
        }
        return fetch.get(Url);
    } else if (method === 'post') {
        return fetch.post(requestUri, data);
    } else if (method === 'delete') {
        return fetch.delete(requestUri, { data });
    } else if (method === 'put') {
        return fetch.put(requestUri, data);
    }
};

export function cancelFetches() {
    cancels.forEach(cancel => {
        cancel({ canceled: true });
    });
    cancels = [];
}
